import { X } from "lucide-react";
import { MapBase } from "@/components/MapBase";
import { Marker } from "react-map-gl/mapbox";
import { MapPin } from "lucide-react";
import { Button } from "@/components/ui/button";

type MapPreviewProps = {
	latitude: number;
	longitude: number;
	onClose: () => void;
};

export const MapPreview = ({ latitude, longitude, onClose }: MapPreviewProps) => {
	return (
		<div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80" onClick={onClose}>
			<div className="relative w-[90vw] h-[90vh] rounded-lg overflow-hidden" onClick={e => e.stopPropagation()}>
				<MapBase
					initialViewState={{
						latitude,
						longitude,
						zoom: 17,
					}}
				>
					<Marker latitude={latitude} longitude={longitude} anchor="bottom">
						<MapPin className="w-8 h-8 text-white fill-primary" />
					</Marker>
				</MapBase>
				<Button variant="secondary" size="icon" className="absolute top-4 right-4 z-10" onClick={onClose}>
					<X className="w-4 h-4" />
				</Button>
			</div>
		</div>
	);
};
